import React, { useState } from "react";
import "./InboundCalls.css";
import { FaPhoneAlt, FaPhone, FaMobileAlt } from "react-icons/fa";

export default function InboundCalls(): JSX.Element {
  const [open, setOpen] = useState<string | null>(null);

  const accessFees = [
    { name: "Standard (13/1300/1800 Number)", unit: "Monthly", rate: "$20.00" },
    { name: "Word (13/1300/1800)", unit: "Monthly", rate: "$99.00" },
  ];

  const rateGroups = [
    {
      key: "1300",
      title: "1300 Inbound Rates",
      rows: [
        { origin: "Local Landline (first 15 min free)", to: "Landline", unit: "Per Minute", rate: "$0.07" },
        { origin: "National Landline", to: "Landline", unit: "Per Minute", rate: "$0.07" },
        { origin: "Mobile", to: "Landline", unit: "Per Minute", rate: "$0.15" },
        { origin: "Landline", to: "Mobile", unit: "Per Minute", rate: "$0.15" },
        { origin: "Mobile", to: "Mobile", unit: "Per Minute", rate: "$0.15" },
      ],
    },
    {
      key: "1800",
      title: "1800 Inbound Rates",
      rows: [
        { origin: "Local Landline", to: "Landline", unit: "Per Minute", rate: "$0.07" },
        { origin: "National Landline", to: "Landline", unit: "Per Minute", rate: "$0.07" },
        { origin: "Mobile", to: "Landline", unit: "Per Minute", rate: "$0.15" },
        { origin: "Landline", to: "Mobile", unit: "Per Minute", rate: "$0.15" },
        { origin: "Mobile", to: "Mobile", unit: "Per Minute", rate: "$0.15" },
      ],
    },
  ];

  const toggle = (key: string) => {
    setOpen((prev) => (prev === key ? null : key));
  };

  return (
    <main className="inbound-page">
      {/* HERO */}
      <section className="inbound-hero">
        <h1>J-Voice Inbound Services</h1>
        <p>1300 &amp; 1800 business inbound numbers with per-second billing.</p>
      </section>

      {/* PRICING */}
      <section className="inbound-pricing">
        <div className="pricing-header">
          <div>
            <h2>Inbound 1300/1800 Plans</h2>
            <p className="muted">Choose your number style, then open the drawers for rates.</p>
          </div>
        </div>

        <div className="pricing-table">
          <h3>Monthly Access</h3>
          <table>
            <thead>
              <tr>
                <th>Plan</th>
                <th>Unit</th>
                <th>Rate</th>
              </tr>
            </thead>
            <tbody>
              {accessFees.map((row) => (
                <tr key={row.name}>
                  <td>{row.name}</td>
                  <td>{row.unit}</td>
                  <td>{row.rate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="rate-accordion">
          {rateGroups.map((group) => (
            <div
              key={group.key}
              className={`rate-item ${open === group.key ? "open" : ""}`}
            >
              <button className="rate-header" onClick={() => toggle(group.key)}>
                <span>{group.title}</span>
                <span className={`chevron ${open === group.key ? "rotated" : ""}`}>&gt;</span>
              </button>
              {open === group.key && (
                <div className="rate-body">
                  <div className="pricing-table condensed">
                    <table>
                      <thead>
                        <tr>
                          <th>Origin</th>
                          <th>Terminating</th>
                          <th>Unit</th>
                          <th>Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.rows.map((row, idx) => (
                          <tr key={`${group.key}-${idx}`}>
                            <td>{row.origin}</td>
                            <td>{row.to}</td>
                            <td>{row.unit}</td>
                            <td>{row.rate}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <a
          className="inbound-cis"
          href="/docs/Jortel%20Inbound%20Critical%20Information%20Summary.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Critical Information Summary
        </a>
      </section>
      
{/* OVERVIEW */}
      <section className="inbound-overview">
        <h2>Why Choose Jortel Inbound?</h2>

        <div className="inbound-grid">

          <div className="inbound-card">
            <FaPhoneAlt className="icon" />
            <h3>National Routing</h3>
            <p>Route calls anywhere in Australia — landline or mobile.</p>
          </div>

          <div className="inbound-card">
            <FaPhone className="icon" />
            <h3>Per-Second Billing</h3>
            <p>Only pay for what you use. No rounding to the nearest minute.</p>
          </div>

          <div className="inbound-card">
            <FaMobileAlt className="icon" />
            <h3>Flexible Pricing</h3>
            <p>Competitive wholesale rates for both 1300 and 1800 numbers.</p>
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="inbound-cta banner">
        <div className="cta-inner">
          <h2>Need an Inbound Number?</h2>
          <p>Talk to our team and get your 1300/1800 number activated today.</p>
          <a href="/contact" className="btn primary">Talk to an Expert</a>
        </div>
      </section>
    </main>
  );
}
